import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { UiTranslationService } from '@core/services/ui-translation.service';
import { VidstackPlayerComponent } from '@/app/components/vidstack-player/vidstack-player';
import { TrainAsset, TrainFlashcard } from '../../../deck-train.models';

@Component({
  selector: 'app-video-only-train-front',
  imports: [VidstackPlayerComponent],
  templateUrl: './video-only-train-front.html',
  styleUrl: './video-only-train-front.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoOnlyTrainFront {
  private readonly deckTranslations =
    inject(UiTranslationService).namespace('deck');

  readonly card = input.required<TrainFlashcard>();
  readonly videoAsset = input<TrainAsset | null>(null);
  readonly isTextSimpleBackVisible = input(false);
  readonly canSpeakQuestion = input(false);
  readonly isQuestionAudioPlaying = input(false);
  readonly speak = output<void>();

  readonly t = this.deckTranslations.t;

  get videoLabel(): string {
    return this.videoAsset()?.fileName || this.card().frontText;
  }
}
